module.exports = __webpack_public_path__ + "img/hero-top.cac170a3.png";